import { useEffect, useState } from 'react';

import serverTimeSync from 'config/serverTimeSync';

import { MACHINE_STATE } from 'constants/common';

const useTimerHandler = ({ machine, calculateStartingDateIfFutureEvent = false }) => {
  const [timeLeft, setTimeLeft] = useState({});
  const [isTimeOver, setIsTimeOver] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(calculateTimeLeft, 1000);
    return () => clearTimeout(timeout);
  });

  const calculateTimeLeft = () => {
    if (!isTimeOver && typeof serverTimeSync.offsetMs === 'number' && machine) {
      const clientTimestamp = Date.now();

      // If client time has changed more than 6 seconds since the last run, refresh the page
      if (timeLeft?.lastClientTimestamp && Math.abs(clientTimestamp - timeLeft?.lastClientTimestamp) >= 6000) {
        window.location.reload();
        return;
      }

      const endTime = calculateStartingDateIfFutureEvent && machine.state === MACHINE_STATE.WAITING_EVENT_DATE ? machine.event.startDate : machine.event.endDate;
      const difference = +new Date(endTime) - +new Date(clientTimestamp + serverTimeSync.offsetMs);

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
          lastClientTimestamp: clientTimestamp,
        });
      } else {
        setTimeLeft({});
        setIsTimeOver(true);
      }
    }
  };

  return { timeLeft, isTimeOver };
};

export default useTimerHandler;
